"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ttp_exports = {};
__export(ttp_exports, {
  ttpApiConfig: () => ttpApiConfig
});
module.exports = __toCommonJS(ttp_exports);
const ttpApiConfig = {
  "ttp-us": {
    iam: "https://cloud-iam.tiktok-usts.net",
    page: "https://cloud-page.tiktok-usts.net",
    openapi: "https://cloud-openapi.tiktok-usts.net",
    galaxy: "https://bytetree.tiktok-usts.net",
    jwt: "https://cloud.tiktok-usts.net/auth/api",
    bytetree: "https://bytetree.tiktok-usts.net",
    api: "https://cloud-api.tiktok-usts.net",
    bpm: "https://bpm.tiktok-usts.net",
    event: "https://cloud-page.tiktok-usts.net"
  },
  "ttp-us-limited": {
    iam: "https://cloud-iam.tiktok-us.net",
    page: "https://cloud-page.tiktok-us.net",
    openapi: "https://cloud-openapi.tiktok-us.net",
    galaxy: "https://bytetree.tiktok-us.net",
    jwt: "https://cloud-ttp-us.bytedance.net/auth/api",
    bytetree: "https://bytetree.tiktok-us.net",
    api: "https://cloud-api.tiktok-us.net",
    bpm: "https://bpm.tiktok-us.net",
    event: "https://cloud-page.tiktok-us.net"
  },
  "ttp-row": {
    iam: "https://cloud-iam.tiktok-row.net",
    page: "https://cloud-page-i18n.bytedance.net",
    openapi: "https://cloud-openapi-i18n.tiktok-row.net",
    galaxy: "https://bytetree-us.tiktok-row.net",
    jwt: "https://cloud.tiktok-row.net/auth/api",
    bytetree: "https://bytetree-us.tiktok-row.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-i18n.tiktok-row.net",
    event: "https://cloud-openapi-i18n.tiktok-row.net"
  },
  "ttp-row-sg": {
    iam: "https://cloud-iam-sg.tiktok-row.net",
    page: "https://cloud-page-i18n.bytedance.net",
    openapi: "https://cloud-openapi-sg.tiktok-row.net",
    galaxy: "https://bytetree-sg.tiktok-row.net",
    jwt: "https://cloud-sg.tiktok-row.net/auth/api",
    bytetree: "https://bytetree-sg.tiktok-row.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-i18n-sg.tiktok-row.net",
    event: "https://cloud-openapi-sg.tiktok-row.net"
  },
  "ttp-eu": {
    iam: "https://bc-iedt-gw.tiktok-eu.net/api/v1/iam",
    jwt: "https://cloud.tiktok-row.net/auth/api",
    page: "https://cloud-page.bytedance.net",
    openapi: "https://bc-iedt-gw.tiktok-eu.net/api/v1/cloud",
    api: "https://bc-iedt-gw.tiktok-eu.net/api/v1/cloud",
    event: "https://bc-iedt-gw.tiktok-eu.net/api/v1/cloud",
    bytetree: "https://bc-iedt-gw.tiktok-eu.net/api/v1/bytetree",
    galaxy: "https://bc-iedt-gw.tiktok-eu.net/api/v1/bytetree",
    bpm: "https://bc-iedt-gw.tiktok-eu.net/api/v1/bpm"
  },
  "ttp-eu-de": {
    iam: "https://bc-dedt-gw.tiktok-eu.net/api/v1/iam",
    jwt: "https://cloud-sg.tiktok-row.net/auth/api",
    page: "https://cloud-page-hl.bytedance.net",
    openapi: "https://bc-dedt-gw.tiktok-eu.net/api/v1/cloud",
    api: "https://bc-dedt-gw.tiktok-eu.net/api/v1/cloud",
    event: "https://bc-dedt-gw.tiktok-eu.net/api/v1/cloud",
    bytetree: "https://bc-dedt-gw.tiktok-eu.net/api/v1/bytetree",
    galaxy: "https://bc-dedt-gw.tiktok-eu.net/api/v1/bytetree",
    bpm: "https://bc-dedt-gw.tiktok-eu.net/api/v1/bpm"
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ttpApiConfig
});
